import script from "./Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Edit.vue?vue&type=script&setup=true&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=e78de476&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78de476"]])

export default __exports__